import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { UserNotesComponent } from '@zero/shared/ui-web-components';
import { FaqHintComponent } from '../../components/faq-hint/faq-hint.component';
import { TicketListComponent } from '../../components/ticket-list/ticket-list.component';

@Component({
  templateUrl: './ticket-page.component.html',
  imports: [UserNotesComponent, FaqHintComponent, TicketListComponent],
})
export class TicketPageComponent implements OnInit {
  public ticketToNavigate: string | null = null;
  readonly #route = inject(ActivatedRoute);
  readonly #destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.#route.queryParams.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((params) => {
      this.ticketToNavigate = params['ticket'];
    });
  }
}
